/* eslint-disable @typescript-eslint/no-explicit-any */
import {CommonModule} from '@angular/common';
import {Component, effect, inject, input, output, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {WorkforceService} from './workforce.service';

@Component({
  selector:'app-workforce-planning-panel',
  imports:[CommonModule, FormsModule, TranslatePipe],
  templateUrl:'./planning-panel.component.html',
  styleUrls:['../schedule/dialog/add-schedule/add-schedule.dialog.scss'],
})
export class PlanningPanelComponent {
  private api = inject(WorkforceService);
  employee = input(''); selectedDate = input(''); shift = input<any>(null);
  absence = input<any>(null);
  changed = output();
  options = signal<any>({workers:[], sites:[]});
  error = signal(false);busy = signal(false);
  projects = signal<{id: string;name: string}[]>([]);
  project = '';
  async loadProjects(preserve = '') {
    const site = this.site;this.project = preserve;this.projects.set([]);
    if (!site) {
return;
}
    try {
const result = await this.api.request<{projects: {id: string;name: string}[]}>('options?scope=projects&projectSite=' + encodeURIComponent(site));if (this.site === site) {
this.projects.set(result.projects);
}
} catch {
if (this.site === site) {
this.error.set(true);
}
}
  }

  mode = 'shift';worker = '';site = '';start = '';end = '';from = '08:00';until = '16:00';unpaid = 30;note = '';type = 'HOLIDAY';quantity = 1;compensationType = 'KILOMETRES';weekdays = true;
  constructor(){
    effect(()=>{
      const absence = this.absence(), shift = this.shift();
      this.worker = this.employee();this.start = this.selectedDate();this.end = this.start;
      if (absence){
this.mode = 'absence';this.worker = absence.firestore_user_id;this.start = absence.start_date;this.end = absence.end_date;this.type = absence.type;this.note = absence.note || '';
} else if (shift){
this.mode = 'shift';this.site = shift.firestore_site_id;void this.loadProjects(shift.firestore_project_id || '');this.from = shift.start_time?.slice(0, 5) || '';this.until = shift.end_time?.slice(0, 5) || '';this.unpaid = shift.unpaid_break_minutes;this.note = shift.note || '';
}
    });
    void this.api.request('options?scope=filters').then(o=>this.options.set(o)).catch(()=>this.error.set(true));
  }

  async save(cancelled = false){
    if (this.busy()) {
return;
} this.busy.set(true);this.error.set(false);
    try {
      const base = {firestore_user_id:this.worker, firestore_site_id:this.site, firestore_project_id:this.project || null, note:this.note};
      if (this.mode === 'absence') {
await this.api.request('absences', 'POST', {...base, start_date:this.start, end_date:this.end, type:this.type, ...this.absence() ? {id:this.absence().id, version:this.absence().version} : {}, cancelled});
} else if (this.mode === 'compensation') {
await this.api.request('compensations', 'POST', {...base, compensation_date:this.start, type:this.compensationType, quantity:this.quantity});
} else {
await this.api.request('shifts', 'POST', {...base, start_date:this.start, end_date:this.shift() ? this.start : this.end, start_time:this.from, end_time:this.until, unpaid_break_minutes:this.unpaid, weekdays:this.shift() || !this.weekdays ? [0, 1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5], ...this.shift() ? {id:this.shift().id, version:this.shift().draft_revision} : {}, cancelled});
}
      this.changed.emit();
    } catch {
this.error.set(true);
} finally {
this.busy.set(false);
}
  }
}
